<!--<div class="floatinghead clearfix" *ngIf="!rentTermsAutoCalc && IsEditAllowed">
    <label class="bluelabel">&nbsp;</label>
    <button href="#" tooltip="Add A RentTerm" (click)="addRentTerm(templateEditRentTermTable,'panlestyle')" placement="left" class="right-btn btn  btn-circle btn-green adduserbtn">
        <i class="icofont icofont-plus icon" aria-hidden="true"></i>
    </button>
</div>-->
<div class="table-responsive">
    <table class="table basictable" *ngIf="PropertyRentTerm?.length != 0">
        <thead>
            <tr>                
                <th>Years</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Rent / NOI</th>
                <th>Increase Percentage</th>
                <th *ngIf="!rentTermsAutoCalc && IsEditAllowed">Actions</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let item of PropertyRentTerm;let i = index">
                <tr *ngIf="!item.IsOptional"  [ngClass]="{'blue-heighligt': showCurrentDate(item)}">
                    <td>
                        <p>{{item.Years}}</p>
                    </td>
                    <td>
                        <p>{{item.LeaseStartDate  | date: 'MM/dd/yyyy'}}</p>
                        <span ng-bind="item.LeaseStartDate | date: 'mediumDate'" id="dtText"></span>
                    </td>
                    <td>
                        <p>{{item.LeaseEndDate | date: 'MM/dd/yyyy'}}</p>
                    </td>
                    <td class="amount">
                        <p>${{item.NetOperatingIncome |  number: '1.0-0'}}</p>
                    </td>
                    <td>
                        <p>{{item.Increase |  number: '1.0-2'}}%</p>
                    </td>
                    <td *ngIf="!rentTermsAutoCalc && IsEditAllowed">
                        <a (click)="openEditRentTermTable(templateEditRentTermTable,'panlestyle',item,i)"><i aria-hidden="true" class="icofont icofont-ui-edit" (click)="edit"></i></a>
                        <a class="remove" tooltip="Remove" href="javascript:void(0);" (click)="openModal(template,'deletemodal',i)"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                    </td>
                </tr>
                <tr *ngIf="showRentTermOptions(i)">
                    <td class="table-heading" *ngIf="!rentTermsAutoCalc && IsEditAllowed" colspan="6">Options</td>

                    <td class="table-heading" *ngIf="!(!rentTermsAutoCalc && IsEditAllowed)" colspan="5">Options</td>
                </tr>
                <tr *ngIf="item.IsOptional"  [ngClass]="{'blue-heighligt': showCurrentDate(item)}">
                    <td>
                        <p>{{item.Years}}</p>
                    </td>
                    <td>
                        <p>{{item.LeaseStartDate  | date: 'MM/dd/yyyy'}}</p>
                        <span ng-bind="item.LeaseStartDate | date: 'mediumDate'" id="dtText"></span>
                    </td>
                    <td>
                        <p>{{item.LeaseEndDate | date: 'MM/dd/yyyy'}}</p>
                    </td>
                    <td class="amount">
                        <p>${{item.NetOperatingIncome |  number: '1.0-0'}}</p>
                    </td>
                    <td>
                        <p>{{item.Increase |  number: '1.0-2'}}%</p>
                    </td>
                    <td *ngIf="!rentTermsAutoCalc && IsEditAllowed">
                        <a (click)="openEditRentTermTable(templateEditRentTermTable,'panlestyle',item,i)"><i aria-hidden="true" class="icofont icofont-ui-edit" (click)="edit"></i></a>
                        <a class="remove" tooltip="Remove" href="javascript:void(0);" (click)="openModal(template,'deletemodal',i)"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                    </td>
                </tr>
            </ng-container>

</tbody>
    </table>
    
</div>
<input type="hidden" (click)="addRentTerm(templateEditRentTermTable,'panlestyle')" id="hdnAddRentTermTable" />
<ng-template #templateEditRentTermTable>
    <app-edit-rent-term-table [PropertyRentTerm]="PropertyRentTerm" (save)="saveRentTerm($event)" [currentRentTermDetails]="currentRentTermDetails" (close)="closeModal($event)"></app-edit-rent-term-table>
</ng-template>
<ng-template #template>

    <div class="modal-header">
        <h4 class="modal-title pull-left">Delete Rent Term ?</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">

        <div class="form-group">
            <h6 class="displayvalue">Are you sure to delete ?</h6>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
            <button class="btn btn-lg btn-danger" (click)="deleteRentTerm();modalRef.hide();">Delete</button>
        </div>
    </div>
</ng-template>



<style>
    .grayBaground > td {
        background-color: #EDF2F5;
    }
    .dark > td {
      font-weight : 900;
    }
</style>